import React, { useState, useEffect } from 'react';
import { Redirect } from 'js/components/common/Redirect';
import { isExternalUrl, getPathWithParams } from 'js/utils/url.util';

import * as Types from './types';
import * as hooks from './hooks';

export const PageUrlTemplate = ({ priority, templateType, locale }: Types.PageUrlTemplateProps) => {
    const [templateUrl, setTemplateUrl] = useState('');
    const getTemplateUrl = hooks.useGetTemplateUrl();

    useEffect(() => {
        getTemplateUrl({
            priority, templateType, setTemplateUrl
        });
    }, [priority, templateType, getTemplateUrl]);

    if (!templateUrl) {
        return null;
    }

    return (
        <Redirect
            isReplace
            to={isExternalUrl(templateUrl) ? templateUrl : `${locale}${getPathWithParams(templateUrl)}`}
        />
    );
};
